import { useMemo, useState } from 'react';
import { Segmented } from 'antd';
import { ProductCard } from './ProductCard';
import { PRODUCTS, CATEGORIES, type ProductCategory } from './products';

export function ProductsPage() {
    const [cat, setCat] = useState<ProductCategory>('insurance');

    const visible = useMemo(
        () => PRODUCTS.filter((p) => p.cat === cat),
        [cat],
    );

    return (
        <div className="page-wrap">
            <div className="products-head">
                <div>
                    <h1 className="products-title">Выберите продукт для оформления</h1>
                    <p className="products-sub">
                        Подберите нужный тип страхования — дальше заполните форму вместе с клиентом и получите вознаграждение.
                    </p>
                </div>
            </div>

            <div className="cat-tabs">
                <Segmented
                    value={cat}
                    onChange={(v) => setCat(v as ProductCategory)}
                    options={CATEGORIES.map((c) => ({
                        value: c.value,
                        label: c.hint ? `${c.label} · ${c.hint}` : c.label,
                        disabled: c.disabled,
                    }))}
                />
            </div>

            {visible.length > 0 ? (
                <div className="product-grid">
                    {visible.map((p) => (
                        <ProductCard key={p.key} product={p} />
                    ))}
                </div>
            ) : (
                <div className="empty-state">
                    <div className="icon">◌</div>
                    <div className="title">Раздел скоро появится</div>
                    <div className="desc">Мы работаем над запуском этой категории.</div>
                </div>
            )}
        </div>
    );
}
